import { render, staticRenderFns } from "./MainPageStandalone.vue?vue&type=template&id=7e0e3f5b&scoped=true"
import script from "./MainPageStandalone.vue?vue&type=script&lang=js"
export * from "./MainPageStandalone.vue?vue&type=script&lang=js"
import style0 from "./MainPageStandalone.vue?vue&type=style&index=0&id=7e0e3f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0e3f5b",
  null
  
)

export default component.exports